export const ERROR_CODE_INVALID_CREDENTIALS = "Missing password";
export const ERROR_CODE_USER_NOT_FOUND = "user not found";
